import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MERCADERIA_REBAJA_ADICIONAL } from '../../../../config/tables'

function MercaderiaRebajaAdicionalView () {
  return (
    <MuiTable id={TABLA_MERCADERIA_REBAJA_ADICIONAL} />
  )
}

export default MercaderiaRebajaAdicionalView
